<template lang="pug">
  #location-faqs
    .container
      h2.f-secondary.xs-f-grande.md-f-xxgrande.max-at-tweak.capitalize.text-center(v-if="cmsSettings?.faqsTitle") {{ cmsSettings.faqsTitle }}
      p.mt-10.xs-mr-100m.xs-ml-100m.text-center(v-if="cmsSettings?.faqsSubtitle") {{ cmsSettings.faqsSubtitle }}

      .faqs-wrap.mt-20
        .question-answer(v-for="(faq, idx) in faqs" :key="idx")
          toggle(v-slot="s")
            LocationFAQ(:faq="faq" :index="idx" :s="s")

</template>
<script>
  import { mapState } from "vuex";
  import LocationFAQ from './LocationFAQ';

  export default {
    name: "LocationFAQs",
    components: {
      LocationFAQ
    },

    props: {
      faqs: {
        type: Array,
        default: () => []
      },

      cmsSettings: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState('colorbar', [
        'location',
        'locationLoading'
      ]),
    },
    methods: {
      toggle(s, index) {
        if (s.val === 0) {
          this.trackMREvent('HCB Location Page - FAQs clicked');
        }
        s.toggleVal(index + 1);
      }
    }
  };
</script>
<style scoped lang="stylus">
  #location-faqs
    background-color cta-color-4
    color ui-color-1
    max-width 1300px
    .container
      max-width 800px
      min-height 200px
      margin 0 auto
      display flex
      flex-direction column
      align-items center
      padding 4em 0.5em
      margin-top 2em

      .faqs-wrap
        width 100%
        .question-answer
          background-color #9C499C
          border-radius 16px
          margin 1em
</style>
